var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertTypeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_33",
    "data-name": "Group 33",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.314,
    height: 11.842,
    viewBox: "0 0 12.314 11.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M11.085,11.842H1.229a1.221,1.221,0,0,1-1.065-.662,1.421,1.421,0,0,1,0-1.324L5.092.663a1.187,1.187,0,0,1,2.13,0l4.928,9.194a1.418,1.418,0,0,1,0,1.324A1.221,1.221,0,0,1,11.085,11.842ZM6.157,1.324,1.229,10.518h9.855L6.157,1.324Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,.642V3.321a.616.616,0,0,0,.587.642.616.616,0,0,0,.587-.642V.642A.616.616,0,0,0,.587,0,.616.616,0,0,0,0,.642Z",
    transform: "translate(5.425 3.71)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.174.642A.589.589,0,1,1,0,.642a.589.589,0,1,1,1.174,0",
    transform: "translate(5.425 8.015)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTypeIcon);
export default __webpack_public_path__ + "static/media/AlertType-Icon.536ff1085eff147a76407a4d4f19ec41.svg";
export { ForwardRef as ReactComponent };